import React, { useState, useMemo } from "react";
import "./ItemsGridSection.scss";
import { Search } from "../../../archive_project/assets";
import PreCard from "../PreCard/PreCard";
import { MARKET_ABI2 } from "../../../contracts/contracts";
import { MARKET_ADDRESS } from "../Market/Market";
import { useNavigate } from "react-router-dom";

const ItemsGridSection = ({ items = [], collections = [], nftData = {} }) => {
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");

  const navigate = useNavigate();

  const enrichedItems = useMemo(() => {
    return (items || []).map((item) => {
      const meta = nftData?.[item.id];

      return {
        ...item,

        name: meta?.name || item.name,

        image: meta?.image || item.image || item.preview,

        description:
          meta?.description || item.description || "No description available",

        size:
          meta?.attributes?.find((a) => a.trait_type === "Size")?.value ||
          item.size,

        year:
          meta?.attributes?.find((a) => a.trait_type === "Year")?.value ||
          item.year,

        collection: item.nft?.name || "Unknown Collection5",
        collectiondesc: item.nft?.description || "No description available",

        collectionMeta: item.nft,
      };
    });
  }, [items, nftData]);

  const filteredItems = useMemo(() => {
    const value = search.trim().toLowerCase();
    if (!value) return enrichedItems;

    return enrichedItems.filter((item) =>
      item.name?.toLowerCase().includes(value),
    );
  }, [enrichedItems, search]);

  const totalPages = Math.ceil(filteredItems.length / rowsPerPage);

  const startIndex = (page - 1) * rowsPerPage;
  const currentItems = filteredItems.slice(
    startIndex,
    startIndex + rowsPerPage,
  );

  const handleNext = () => {
    if (page < totalPages) setPage(page + 1);
  };

  const handlePrev = () => {
    if (page > 1) setPage(page - 1);
  };

  const handleItemOpen = (item) => {
    const contractAddress =
      item.collections?.id ||
      item.nft?.id ||
      item?.collections?.tokens?.id ||
      item.token?.collection?.id ||
      item.token?.id;
    const tokenId = item.token?.tokenId || item.tokenId || item.id;

    navigate(`/reproduction/${contractAddress}/${tokenId}`, {
      state: {
        item,
        metadataUri: item.metadataUri,

        contractMetadataUri: item.token?.collection?.contractMetadataUri,

        contractURI: item.token?.collection?.contractURI,

        collectionId: item.token?.collection?.id,

        collection: item.nft?.name,
      },
    });
  };

  return (
    <section className="items">
      <div className="items__container">
        <div className="search-wrapper">
          <img src={Search} alt="Search" className="search-icon" />

          <input
            type="text"
            placeholder="Search..."
            className="search-input2"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setPage(1);
            }}
          />

          {search && (
            <span className="clear-btn" onClick={() => setSearch("")}>
              ✖
            </span>
          )}
        </div>

        <div className="items__grid">
          {currentItems.length > 0 ? (
            currentItems.map((item) => (
              <PreCard
                key={item.id}
                item={item}
                tokens="tokens"
                ETH="ETH"
                marketAddress={MARKET_ADDRESS}
                marketAbi={MARKET_ABI2}
                useFormattedPrice={true}
                onClick={() => handleItemOpen(item)}
              />
            ))
          ) : (
            <p>No items found</p>
          )}
        </div>

        <div className="items__pagination">
          <div className="items__rows rows">
            Rows per page:
            <select
              value={rowsPerPage}
              onChange={(e) => {
                setRowsPerPage(Number(e.target.value));
                setPage(1);
              }}
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
            </select>
          </div>

          <div className="pages">
            <span>
              Page {page} / {totalPages || 1}
            </span>

            <button onClick={handlePrev} disabled={page === 1}>
              ‹
            </button>

            <button onClick={handleNext} disabled={page === totalPages}>
              ›
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ItemsGridSection;
